<template>
  <div class="infrastructure-container">
    <div class="page-header">
      <div class="breadcrumb">ຂໍ້ມູນໂຮງຮຽນ / <span>ຂໍ້ມູນພື້ນຖານໂຄງລ່າງ</span></div>
      <div class="header-content">
        <h1>ຈັດການຂໍ້ມູນພື້ນຖານໂຄງລ່າງ</h1>
        <p>ບັນທຶກ ແລະ ປັບປຸງຂໍ້ມູນອາຄານ, ສະຖານທີ່ ແລະ ທີ່ດິນຂອງໂຮງຮຽນ</p>
      </div>
    </div>

    <div v-if="loading" class="loading-state-full">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
      <p>ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
    </div>

    <form v-else @submit.prevent="handleSubmit">

      <!-- ===== HEADER CARD: School identity ===== -->
      <div class="info-card mb-4">
        <div class="section-label"><i class="fas fa-school"></i> ຂໍ້ມູນລະບຸໂຮງຮຽນ</div>
        <div class="field-row-4">
          <div class="form-group">
            <label class="req">1. ສົກຮຽນ</label>
            <input type="text" v-model="form.academic_year" placeholder="ຕົວຢ່າງ: 2024-2025"
                   pattern="\d{4}-\d{4}" title="ຮູບແບບ: YYYY-YYYY" maxlength="9">
          </div>
          <div class="form-group">
            <label>2. ລະຫັດໂຮງຮຽນ</label>
            <input type="text" :value="schoolInfo.school_id || user.school_id || user.school_code" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>7. ຊື່ໂຮງຮຽນ</label>
            <input type="text" :value="schoolInfo.school_name_lao || user.school_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>3. ຊື່ແຂວງ</label>
            <input type="text" :value="schoolInfo.prov_name || user.prov_name || user.province_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
        </div>
        <div class="field-row-4">
          <div class="form-group">
            <label>4. ຊື່ເມືອງ</label>
            <input type="text" :value="schoolInfo.district_name_lao || user.district_name_lao || user.district_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>5. ຊື່ຕາແສງ</label>
            <input type="text" :value="schoolInfo.commune_name || ''" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>6. ຊື່ບ້ານທີ່ໂຮງຮຽນຕັ້ງຢູ່</label>
            <input type="text" :value="schoolInfo.school_village || ''" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>8. ປີສ້າງຕັ້ງໂຮງຮຽນ</label>
            <input type="text" v-model="form.established_year" placeholder="YYYY" maxlength="4">
          </div>
        </div>
        <div class="field-row">
          <div class="form-group">
            <label>9. ທຶນກໍ່ສ້າງ (ກີບ)</label>
            <input type="number" v-model.number="form.construction_cost" placeholder="0" min="0">
          </div>
        </div>
      </div>

      <!-- ===== TABS ===== -->
      <div class="tabs-container shadow-sm">
        <div class="tabs-nav">
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'general' }" @click="activeTab = 'general'">
            <i class="fas fa-info-circle"></i> ທົ່ວໄປ
          </button>
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'rooms' }" @click="activeTab = 'rooms'">
            <i class="fas fa-door-open"></i> ຂໍ້ມູນຫ້ອງ
            <span class="badge-count">{{ form.rooms.length }}</span>
          </button>
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'buildings' }" @click="activeTab = 'buildings'">
            <i class="fas fa-building"></i> ຂໍ້ມູນອາຄານ
            <span class="badge-count">{{ form.buildings.length }}</span>
          </button>
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'land' }" @click="activeTab = 'land'">
            <i class="fas fa-map-marked-alt"></i> ທີ່ຕັ້ງ &amp; ທີ່ດິນ
          </button>
        </div>

        <div class="tab-content">

          <!-- ============================================================ -->
          <!-- TAB 1: ຂໍ້ມູນທົ່ວໄປ                                         -->
          <!-- ============================================================ -->
          <div v-if="activeTab === 'general'" class="tab-pane">

            <!-- ມື້ເຂົ້າຮຽນ (12, 13) -->
            <div class="section-title">ຈຳນວນມື້ເຂົ້າຮຽນ</div>
            <div class="field-row">
              <div class="form-group">
                <label>12. ມື້ເຂົ້າຮຽນທາງການ (ສົກຮຽນນີ້)</label>
                <input type="number" v-model.number="form.official_days_current" placeholder="ຈຳນວນມື້" min="0">
              </div>
              <div class="form-group">
                <label>13. ມື້ເຂົ້າຮຽນທາງການ (ສົກຮຽນປີກາຍ)</label>
                <input type="number" v-model.number="form.official_days_last" placeholder="ຈຳນວນມື້" min="0">
              </div>
            </div>

            <!-- ໂຮງຮຽນອື່ນໃນຮົ້ວດຽວ (14) -->
            <div class="section-title mt-4">14. ໂຮງຮຽນອື່ນ ທີ່ຢູ່ໃນຂອບເຂດຮົ້ວດຽວກັນ</div>
            <div class="alert-info mb-3">
              <i class="fas fa-info-circle"></i>
              ສາມາດເລືອກໄດ້ຫຼາຍລາຍການ. ຖ້າເລືອກ "ບໍ່ມີໂຮງຮຽນອື່ນ" ຈະລ້າງລາຍການອື່ນທັງໝົດ.
            </div>
            <div class="checkbox-grid">
              <label v-for="s in OPTIONS.OTHER_SCHOOLS" :key="s.value" class="check-item"
                     :class="{ disabled: isNoOtherSchool && s.value !== 1 }">
                <input type="checkbox"
                       :value="s.value"
                       v-model="form.other_schools_in_fence"
                       @change="handleOtherSchoolChange(s.value)"
                       :disabled="isNoOtherSchool && s.value !== 1">
                <span>{{ s.value }}. {{ s.label }}</span>
              </label>
            </div>

            <!-- ປະເພດໂຮງຮຽນ (15) -->
            <div class="section-title mt-4">ປະເພດໂຮງຮຽນ ແລະ ລະດັບການສຶກສາ</div>
            <div class="field-row">
              <div class="form-group">
                <label>15. ໂຮງຮຽນແຫ່ງນີ້ ເປັນໂຮງຮຽນປະເພດໃດ</label>
                <select v-model.number="form.school_type">
                  <option value="">-- ເລືອກ --</option>
                  <option v-for="t in OPTIONS.SCHOOL_TYPES" :key="t.value" :value="t.value">{{ t.value }}. {{ t.label }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>16. ໃຫ້ບໍລິການສຶກສາຊັ້ນໃດ</label>
                <select v-model.number="form.education_level" @change="clearEducationSubType">
                  <option value="">-- ເລືອກ --</option>
                  <option v-for="l in OPTIONS.EDUCATION_LEVELS" :key="l.value" :value="l.value">{{ l.value }}. {{ l.label }}</option>
                </select>
              </div>
            </div>

            <!-- 16.1: ກ່ອນໄວຮຽນ ຫຼື ຫຼັກສູດອື່ນ -->
            <div v-if="form.education_level === 1 || form.education_level === 4" class="form-group conditional-field">
              <div class="cond-flag"><i class="fas fa-arrow-right"></i> ສະແດງຍ້ອນ 16 = ກ່ອນໄວຮຽນ / ຫຼັກສູດອື່ນ</div>
              <label>16.1 ໂຮງຮຽນແຫ່ງນີ້ ໃຫ້ການສຶກສາໃດ (ກ່ອນໄວຮຽນ)</label>
              <select v-model.number="form.pre_primary_type">
                <option value="">-- ເລືອກ --</option>
                <option v-for="t in OPTIONS.PRE_PRIMARY_TYPES" :key="t.value" :value="t.value">{{ t.value }}. {{ t.label }}</option>
              </select>
            </div>

            <!-- 16.2: ປະຖົມ -->
            <div v-if="form.education_level === 2" class="form-group conditional-field">
              <div class="cond-flag"><i class="fas fa-arrow-right"></i> ສະແດງຍ້ອນ 16 = ປະຖົມ</div>
              <label>16.2 ໂຮງຮຽນແຫ່ງນີ້ ໃຫ້ການສຶກສາໃດ (ປະຖົມ)</label>
              <select v-model.number="form.primary_type">
                <option value="">-- ເລືອກ --</option>
                <option v-for="t in OPTIONS.PRIMARY_TYPES" :key="t.value" :value="t.value">{{ t.value }}. {{ t.label }}</option>
              </select>
            </div>

            <!-- 16.3: ມັດທະຍົມ -->
            <div v-if="form.education_level === 3" class="form-group conditional-field">
              <div class="cond-flag"><i class="fas fa-arrow-right"></i> ສະແດງຍ້ອນ 16 = ມັດທະຍົມ</div>
              <label>16.3 ໂຮງຮຽນແຫ່ງນີ້ ໃຫ້ການສຶກສາໃດ (ມັດທະຍົມ)</label>
              <select v-model.number="form.secondary_type">
                <option value="">-- ເລືອກ --</option>
                <option v-for="t in OPTIONS.SECONDARY_TYPES" :key="t.value" :value="t.value">{{ t.value }}. {{ t.label }}</option>
              </select>
            </div>
          </div>

          <!-- ============================================================ -->
          <!-- TAB 2: ຂໍ້ມູນຫ້ອງ (10, 10.1–10.4)                          -->
          <!-- ============================================================ -->
          <div v-if="activeTab === 'rooms'" class="tab-pane">
            <div class="summary-banner mb-4">
              <div class="summary-item">
                <i class="fas fa-door-closed"></i>
                <div class="details">
                  <span class="label">ຫ້ອງທີ່ຕື່ມຂໍ້ມູນ</span>
                  <span class="value">{{ form.rooms.length }} ຫ້ອງ</span>
                </div>
              </div>
              <div class="summary-item">
                <i class="fas fa-chart-area"></i>
                <div class="details">
                  <span class="label">ເນື້ອທີ່ທັງໝົດ</span>
                  <span class="value">{{ totalRoomArea }} ຕ.ມ</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>10. ຈໍານວນຫ້ອງໃນອາຄານທັງໝົດ</label>
              <input type="number" v-model.number="form.total_rooms" placeholder="0" min="0">
              <div v-if="roomCountMismatch" class="validation-warning">
                <i class="fas fa-exclamation-triangle"></i>
                ຈຳນວນຫ້ອງທີ່ປ້ອນ ({{ form.total_rooms }}) ບໍ່ກົງກັບລາຍການຫ້ອງທີ່ຕື່ມຂໍ້ມູນ ({{ form.rooms.length }} ຫ້ອງ)
              </div>
            </div>

            <div v-for="(r, index) in form.rooms" :key="index" class="record-card mb-4">
              <div class="record-header">
                <h4><i class="fas fa-door-open"></i> ຫ້ອງທີ {{ index + 1 }}</h4>
                <button type="button" class="btn-remove-text" @click="removeRoom(index)">
                  <i class="fas fa-trash-alt"></i> ລຶບ
                </button>
              </div>

              <!-- 10.1 ປະເພດຫ້ອງ -->
              <div class="form-group">
                <label>10.1 ຫ້ອງນີ້ ໃຊ້ໄວ້ເພື່ອຫຍັງ</label>
                <select v-model.number="r.room_type" @change="r.grade_level = null">
                  <option value="">-- ເລືອກ --</option>
                  <option v-for="t in OPTIONS.ROOM_TYPES" :key="t.value" :value="t.value">{{ t.value }}. {{ t.label }}</option>
                </select>
              </div>

              <!-- 10.2 ຂັ້ນນັກຮຽນ (ສະແດງສະເພາະຖ້າ 10.1 = 1 ຫ້ອງຮຽນ) -->
              <div v-if="r.room_type === 1" class="form-group conditional-field">
                <div class="cond-flag"><i class="fas fa-arrow-right"></i> ສະແດງຍ້ອນ 10.1 = ຫ້ອງຮຽນ</div>
                <label>10.2 ສຳລັບນັກຮຽນຂັ້ນໃດ</label>
                <select v-model.number="r.grade_level">
                  <option value="">-- ເລືອກ --</option>
                  <option v-for="g in OPTIONS.GRADE_LEVELS" :key="g.value" :value="g.value">{{ g.value }}. {{ g.label }}</option>
                </select>
              </div>

              <div class="field-row">
                <!-- 10.3 ອາຍຸໃຊ້ງານ -->
                <div class="form-group">
                  <label>10.3 ສາມາດໃຊ້ໄດ້ຕໍ່ໄປອີກຈັກປີ</label>
                  <select v-model.number="r.life_use">
                    <option value="">-- ເລືອກ --</option>
                    <option v-for="l in OPTIONS.LIFE_USE" :key="l.value" :value="l.value">{{ l.value }}. {{ l.label }}</option>
                  </select>
                </div>
                <!-- 10.4 ເນື້ອທີ່ -->
                <div class="form-group">
                  <label>10.4 ເນື້ອທີ່ (ຕາແມັດ)</label>
                  <input type="number" v-model.number="r.area" placeholder="0" min="0" step="0.01">
                </div>
              </div>
            </div>

            <button type="button" class="btn-add-record" @click="addRoom">
              <i class="fas fa-plus-circle"></i> ເພີ່ມຫ້ອງໃໝ່
            </button>
          </div>

          <!-- ============================================================ -->
          <!-- TAB 3: ຂໍ້ມູນອາຄານ (11, 11.1–11.11)                       -->
          <!-- ============================================================ -->
          <div v-if="activeTab === 'buildings'" class="tab-pane">
            <div class="form-group">
              <label>11. ຈໍານວນອາຄານທັງໝົດ</label>
              <input type="number" v-model.number="form.total_buildings" placeholder="0" min="0">
            </div>

            <div v-for="(b, index) in form.buildings" :key="index" class="record-card mb-4">
              <div class="record-header">
                <h4><i class="fas fa-building"></i> ອາຄານຫຼັງທີ {{ index + 1 }}</h4>
                <button type="button" class="btn-remove-text" @click="removeBuilding(index)" v-if="form.buildings.length > 1">
                  <i class="fas fa-trash-alt"></i> ລຶບ
                </button>
              </div>

              <div class="field-row-3">
                <div class="form-group">
                  <label>11.1 ຈຳນວນຫ້ອງ</label>
                  <input type="number" v-model.number="b.rooms_count" placeholder="0" min="0">
                </div>
                <div class="form-group">
                  <label>11.2 ປຸກສ້າງປີໃດ</label>
                  <input type="number" v-model.number="b.build_year" placeholder="YYYY" min="1900" max="2100">
                </div>
                <div class="form-group">
                  <label>11.3 ແຫຼ່ງທຶນປຸກສ້າງ</label>
                  <select v-model.number="b.funding_source">
                    <option value="">-- ເລືອກ --</option>
                    <option v-for="f in OPTIONS.FUNDING_SOURCES" :key="f.value" :value="f.value">{{ f.value }}. {{ f.label }}</option>
                  </select>
                </div>
              </div>

              <div class="field-row">
                <div class="form-group">
                  <label>11.4 ປະເພດອາຄານ (ໃນປີປຸກສ້າງ)</label>
                  <select v-model.number="b.building_type">
                    <option value="">-- ເລືອກ --</option>
                    <option v-for="t in OPTIONS.BUILDING_TYPES" :key="t.value" :value="t.value">{{ t.value }}. {{ t.label }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>11.5 ໂຄງສ້າງອາຄານ (ໃນປີປຸກສ້າງ)</label>
                  <select v-model.number="b.construction_structure">
                    <option value="">-- ເລືອກ --</option>
                    <option v-for="s in OPTIONS.CONSTRUCTION_STRUCTURES" :key="s.value" :value="s.value">{{ s.value }}. {{ s.label }}</option>
                  </select>
                </div>
              </div>

              <div class="condition-section">
                <div class="condition-title">ສະພາບໂຄງສ້າງໃນປັດຈຸບັນ</div>
                <div class="condition-grid">
                  <div class="form-group" v-for="cond in buildingConditions" :key="cond.key">
                    <label>{{ cond.label }}</label>
                    <select v-model.number="b[cond.key]">
                      <option value="">-- ເລືອກ --</option>
                      <option v-for="c in OPTIONS.CONDITIONS" :key="c.value" :value="c.value">{{ c.value }}. {{ c.label }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <button type="button" class="btn-add-record" @click="addBuilding">
              <i class="fas fa-plus-circle"></i> ເພີ່ມອາຄານໃໝ່
            </button>
          </div>

          <!-- ============================================================ -->
          <!-- TAB 4: ທີ່ຕັ້ງ ແລະ ທີ່ດິນ (17, 19, 20, 21, 22)            -->
          <!-- ============================================================ -->
          <div v-if="activeTab === 'land'" class="tab-pane">

            <!-- ໄລຍະທາງ -->
            <div class="section-title">ໄລຍະທາງ</div>
            <div class="hint-text mb-3">
              <i class="fas fa-info-circle"></i>
              ຕົວຢ່າງ: ຫ່າງ 500 ແມັດ = 0.5 ກມ &nbsp;|&nbsp; ຫ່າງ 1,500 ແມັດ = 1.5 ກມ
            </div>
            <div class="field-row-3">
              <div class="form-group">
                <label>17. ຫ່າງຈາກໂຮງຮຽນປະຖົມ ທີ່ໃກ້ສຸດ (ກມ)</label>
                <input type="number" v-model.number="form.dist_to_primary" step="0.1" min="0" placeholder="0.0">
              </div>
              <div class="form-group">
                <label>19. ຫ່າງຈາກ ຫ້ອງການສຶກສາ ສກມ (ກມ)</label>
                <input type="number" v-model.number="form.dist_to_deo" step="0.1" min="0" placeholder="0.0">
              </div>
              <div class="form-group">
                <label>19. ຫ່າງຈາກ ເສັ້ນທາງໃຫຍ່ (ກມ)</label>
                <input type="number" v-model.number="form.dist_to_road" step="0.1" min="0" placeholder="0.0">
              </div>
            </div>

            <!-- ບ້ານໃນເຂດບໍລິການ (20) -->
            <div class="section-title mt-4">ບ້ານໃນເຂດບໍລິການ</div>
            <div class="form-group">
              <label>20. ຈໍານວນບ້ານໃນເຂດບໍລິການ</label>
              <input type="number" v-model.number="form.village_count" placeholder="0" min="0">
              <div v-if="villageCountMismatch" class="validation-warning">
                <i class="fas fa-exclamation-triangle"></i>
                ຈຳນວນບ້ານທີ່ປ້ອນ ({{ form.village_count }}) ບໍ່ກົງກັບລາຍຊື່ບ້ານທີ່ຕື່ມຂໍ້ມູນ
                ({{ form.villages.filter(v => v.trim()).length }} ບ້ານ)
              </div>
            </div>

            <div class="record-card mb-4">
              <div class="villages-grid">
                <div v-for="(v, idx) in form.villages" :key="idx" class="form-group">
                  <label>{{ idx + 1 }}. ຊື່ບ້ານ</label>
                  <div class="input-group">
                    <input type="text" v-model="form.villages[idx]" placeholder="ຊື່ບ້ານ">
                    <button v-if="form.villages.length > 1" type="button" class="btn-del-mini" @click="removeVillage(idx)" title="ລຶບ">×</button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn-add-mini" @click="addVillage">
                <i class="fas fa-plus"></i> ເພີ່ມບ້ານ
              </button>
            </div>

            <!-- ທີ່ດິນ (21, 22) -->
            <div class="section-title mt-4">ທີ່ດິນ</div>
            <div class="field-row">
              <div class="form-group">
                <label>21. ທາງໂຮງຮຽນ ມີໃບຕາດິນຂອບທອງແລ້ວບໍ່</label>
                <div class="status-selector">
                  <label class="status-btn p" :class="{ active: form.has_land_title == 1 }">
                    <input type="radio" v-model.number="form.has_land_title" :value="1"> ມີ
                  </label>
                  <label class="status-btn a" :class="{ active: form.has_land_title == 0 }">
                    <input type="radio" v-model.number="form.has_land_title" :value="0"> ບໍ່ມີ
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>22. ເນື້ອທີ່ດິນທັງໝົດ (ຕາແມັດ)</label>
                <input type="number" v-model.number="form.total_land_area" min="0" placeholder="0">
              </div>
            </div>
          </div>

        </div><!-- /tab-content -->
      </div><!-- /tabs-container -->

      <div class="form-actions-wrapper mt-4">
        <button type="submit" class="btn-save" :disabled="submitting">
          <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-save'"></i>
          {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກຂໍ້ມູນໂຄງລ່າງ' }}
        </button>
      </div>
    </form>

    <!-- Result Modal -->
    <transition name="modal">
      <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="resultModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon" :class="resultModal.type">
            <i class="fas" :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
          </div>
          <div class="modal-content-area">
            <h2>{{ resultModal.title }}</h2>
            <p>{{ resultModal.message }}</p>
          </div>
          <div class="modal-footer-actions">
            <button class="btn-modal-primary" :class="resultModal.type" @click="resultModal.show = false">ເຂົ້າໃຈແລ້ວ</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/utils/api';

const OPTIONS = {
  ROOM_TYPES: [
    { value: 1, label: 'ຫ້ອງຮຽນ' },
    { value: 2, label: 'ຫ້ອງການ' },
    { value: 3, label: 'ຫ້ອງອ່ານ' },
    { value: 4, label: 'ຫ້ອງປະຖົມພະຍາບານ' },
    { value: 5, label: 'ຫ້ອງກິດຈະກໍາ' },
    { value: 6, label: 'ຫ້ອງຄົວກິນ' },
    { value: 7, label: 'ຫ້ອງອາຫານ' },
    { value: 8, label: 'ຫ້ອງມ້ຽນເຄື່ອງ' },
    { value: 9, label: 'ຫ້ອງອື່ນ' },
    { value: 10, label: 'ຫ້ອງວ່າງ' }
  ],
  GRADE_LEVELS: [
    { value: 1, label: 'ລ້ຽງເດັກອ່ອນ' },
    { value: 2, label: 'ລ້ຽງເດັກກາງ' },
    { value: 3, label: 'ລ້ຽງເດັກໃຫຍ່' },
    { value: 4, label: 'ອະນຸບານ 1' },
    { value: 5, label: 'ອະນຸບານ 2' },
    { value: 6, label: 'ອະນຸບານ 3' },
    { value: 7, label: 'ກຸ່ມຮຽນຜ່ານການຫຼິ້ນ' },
    { value: 8, label: 'ຫຼັກສູດ 10 ອາທິດ' },
    { value: 9, label: 'ປ 1' },
    { value: 10, label: 'ປ 2' },
    { value: 11, label: 'ປ 3' },
    { value: 12, label: 'ປ 4' },
    { value: 13, label: 'ປ 5' },
    { value: 14, label: 'ປ 6' },
    { value: 15, label: 'ມ 1' },
    { value: 16, label: 'ມ 2' },
    { value: 17, label: 'ມ 3' },
    { value: 18, label: 'ມ 4' },
    { value: 19, label: 'ມ 5' },
    { value: 20, label: 'ມ 6' },
    { value: 21, label: 'ມ 7' },
    { value: 22, label: 'ປະຖົມບໍາລຸງລະດັບ 1-2' },
    { value: 23, label: 'ປະຖົມບໍາລຸງລະດັບ 3' },
    { value: 24, label: 'ມັດທະຍົມຕອນຕົ້ນບໍາລຸງ' },
    { value: 25, label: 'ມັດທະຍົມຕອນປາຍບໍາລຸງ' },
    { value: 26, label: 'ອື່ນໆ' }
  ],
  LIFE_USE: [
    { value: 1, label: 'ສູງກວ່າ 15 ປີ' },
    { value: 2, label: '5–15 ປີ' },
    { value: 3, label: 'ຕໍ່າກວ່າ 5 ປີ' }
  ],
  FUNDING_SOURCES: [
    { value: 1, label: 'ພາຍໃນ' },
    { value: 2, label: 'ຕ່າງປະເທດ - ຊ່ວຍເຫຼືອລ້າ' },
    { value: 3, label: 'ຕ່າງປະເທດ - ກູ້ຢຶມ' }
  ],
  BUILDING_TYPES: [
    { value: 1, label: 'ຖາວອນ' },
    { value: 2, label: 'ເຄິ່ງຖາວອນ' },
    { value: 3, label: 'ຊົ່ວຄາວ' }
  ],
  CONSTRUCTION_STRUCTURES: [
    { value: 1, label: 'ຄອນກີດ' },
    { value: 2, label: 'ໄມ້ເໜືອແຂງ, ເຫຼັກ' },
    { value: 3, label: 'ຄອນກີດ, ໄມ້, ເຫຼັກ' },
    { value: 4, label: 'ແບບຊົ່ວຄາວ' }
  ],
  CONDITIONS: [
    { value: 1, label: 'ດີ' },
    { value: 2, label: 'ພໍໃຊ້ໄດ້' },
    { value: 3, label: 'ຊຸດໂຊມ' },
    { value: 4, label: 'ບໍ່ມີໂຄງສ້າງປະເພດນີ້' }
  ],
  OTHER_SCHOOLS: [
    { value: 1, label: 'ບໍ່ມີໂຮງຮຽນອື່ນ' },
    { value: 2, label: 'ໂຮງຮຽນອະນຸບານ' },
    { value: 3, label: 'ໂຮງຮຽນປະຖົມສົມບູນ' },
    { value: 4, label: 'ໂຮງຮຽນມູນລະປະຖົມ' },
    { value: 5, label: 'ໂຮງຮຽນມັດທະຍົມຕົ້ນ' },
    { value: 6, label: 'ໂຮງຮຽນມັດທະຍົມປາຍ' },
    { value: 7, label: 'ໂຮງຮຽນທັດມະຍົມສົມບູນ' },
    { value: 8, label: 'ວິທະຍາໄລຄູ' },
    { value: 9, label: 'ວິທະຍາໄລອື່ນໆ' },
    { value: 10, label: 'ໂຮງຮຽນອາຊີວະອື່ນໆ' },
    { value: 11, label: 'ພາກສ່ວນອື່ນໆ' }
  ],
  SCHOOL_TYPES: [
    { value: 1, label: 'ໂຮງຮຽນລັດ' },
    { value: 2, label: 'ໂຮງຮຽນເອກະຊົນ' },
    { value: 3, label: 'ໂຮງຮຽນຊຸມຊົນ' },
    { value: 4, label: 'ໂຮງຮຽນນາໆຊາດ' }
  ],
  EDUCATION_LEVELS: [
    { value: 1, label: 'ກ່ອນໄວຮຽນ' },
    { value: 2, label: 'ປະຖົມ' },
    { value: 3, label: 'ມັດທະຍົມ' },
    { value: 4, label: 'ຫຼັກສູດອື່ນໆ' }
  ],
  PRE_PRIMARY_TYPES: [
    { value: 1, label: 'ໂຮງລ້ຽງເດັກ' },
    { value: 2, label: 'ໂຮງຮຽນອະນຸບານ' },
    { value: 3, label: 'ລ້ຽງເດັກ ແລະ ອະນຸບານ' }
  ],
  PRIMARY_TYPES: [
    { value: 1, label: 'ມູນລະປະຖົມສຶກສາ' },
    { value: 2, label: 'ປະຖົມສຶກສາສົມບູນ' },
    { value: 3, label: 'ໂຮງຮຽນສົງ - ມູນລະປະຖົມສຶກສາ' },
    { value: 4, label: 'ໂຮງຮຽນສົງ - ປະຖົມສຶກສາສົມບູນ' }
  ],
  SECONDARY_TYPES: [
    { value: 1, label: 'ມັດທະຍົມຕົ້ນ' },
    { value: 2, label: 'ມັດທະຍົມປາຍ' },
    { value: 3, label: 'ມັດທະຍົມສົມບູນ' },
    { value: 4, label: 'ໂຮງຮຽນສົງ - ມັດທະຍົມຕົ້ນ' },
    { value: 5, label: 'ໂຮງຮຽນສົງ - ມັດທະຍົມປາຍ' },
    { value: 6, label: 'ໂຮງຮຽນສົງ - ມັດທະຍົມສົມບູນ' }
  ]
};

function newRoom() {
  return { room_type: null, grade_level: null, life_use: null, area: null };
}
function newBuilding() {
  return {
    rooms_count: null, build_year: null, funding_source: null,
    building_type: null, construction_structure: null,
    cond_structure: null, cond_roof: null, cond_material: null,
    cond_floor: null, cond_wall: null, cond_ceiling: null
  };
}

export default {
  name: 'SchoolInfrastructurePage',
  data() {
    return {
      loading: false,
      submitting: false,
      isNew: true,
      activeTab: 'general',
      user: {},
      schoolInfo: { school_id: '', prov_name: '', district_name_lao: '', school_name_lao: '', commune_name: '', school_village: '' },
      OPTIONS,
      buildingConditions: [
        { key: 'cond_structure', label: '11.6 ສະພາບໂຄງສ້າງ' },
        { key: 'cond_roof',      label: '11.7 ສະພາບຫຼັງຄາ' },
        { key: 'cond_material',  label: '11.8 ສະພາບວັດສະດຸມຸງ' },
        { key: 'cond_floor',     label: '11.9 ສະພາບພື້ນ' },
        { key: 'cond_wall',      label: '11.10 ສະພາບຝາ' },
        { key: 'cond_ceiling',   label: '11.11 ສະພາບເພດານ' }
      ],
      form: {
        school_id: '',
        academic_year: '',
        commune_name: '',
        school_village: '',
        established_year: '',
        construction_cost: null,
        total_rooms: null,
        rooms: [newRoom()],
        total_buildings: null,
        buildings: [newBuilding()],
        official_days_current: null,
        official_days_last: null,
        other_schools_in_fence: [],
        school_type: null,
        education_level: null,
        pre_primary_type: null,
        primary_type: null,
        secondary_type: null,
        dist_to_primary: null,
        dist_to_deo: null,
        dist_to_road: null,
        village_count: null,
        villages: [''],
        has_land_title: 0,
        total_land_area: null
      },
      resultModal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  computed: {
    totalRoomArea() {
      return this.form.rooms.reduce((sum, r) => sum + (parseFloat(r.area) || 0), 0).toLocaleString();
    },
    isNoOtherSchool() {
      return this.form.other_schools_in_fence.includes(1);
    },
    roomCountMismatch() {
      return this.form.total_rooms !== null &&
             this.form.total_rooms !== '' &&
             Number(this.form.total_rooms) !== this.form.rooms.length;
    },
    villageCountMismatch() {
      const filled = this.form.villages.filter(v => v.trim()).length;
      return this.form.village_count !== null &&
             this.form.village_count !== '' &&
             Number(this.form.village_count) !== filled;
    }
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user-info') || '{}');
    await Promise.all([this.fetchSchoolInfo(), this.fetchInfrastructureData()]);
  },
  methods: {
    async fetchSchoolInfo() {
      if (!this.user.school_id) return;
      try {
        const res = await api.get(`/getAll/schools/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          const s = res.data.rows[0];
          this.schoolInfo = {
            school_id: s.school_id || this.user.school_id,
            prov_name: s.prov_name || '',
            district_name_lao: s.district_name_lao || '',
            school_name_lao: s.school_name_lao || '',
            commune_name: s.commune_name || '',
            school_village: s.school_village || '',
          };
        }
      } catch (e) { console.error(e); }
    },
    handleOtherSchoolChange(val) {
      if (val === 1 && this.form.other_schools_in_fence.includes(1)) {
        this.form.other_schools_in_fence = [1];
      }
    },
    clearEducationSubType() {
      this.form.pre_primary_type = null;
      this.form.primary_type = null;
      this.form.secondary_type = null;
    },
    addRoom() { this.form.rooms.push(newRoom()); },
    removeRoom(i) { this.form.rooms.splice(i, 1); },
    addBuilding() { this.form.buildings.push(newBuilding()); },
    removeBuilding(i) { this.form.buildings.splice(i, 1); },
    addVillage() { this.form.villages.push(''); },
    removeVillage(i) { this.form.villages.splice(i, 1); },
    showResult(type, title, message) {
      this.resultModal = { show: true, type, title, message };
    },
    async fetchInfrastructureData() {
      if (!this.user.school_id) return;
      this.loading = true;
      try {
        const res = await api.get(`/getAll/school_infrastructure/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          const d = res.data.rows[0];
          if (!Array.isArray(d.rooms) || !d.rooms.length) d.rooms = [newRoom()];
          if (!Array.isArray(d.buildings) || !d.buildings.length) d.buildings = [newBuilding()];
          if (!Array.isArray(d.villages) || !d.villages.length) d.villages = [''];
          if (!Array.isArray(d.other_schools_in_fence)) d.other_schools_in_fence = [];
          this.form = { ...this.form, ...d };
          this.isNew = false;
        } else {
          this.form.school_id = this.user.school_id;
          this.isNew = true;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    async handleSubmit() {
      this.submitting = true;
      try {
        let res;
        if (this.isNew) {
          res = await api.post('/insertOne', { table: 'school_infrastructure', items: this.form });
        } else {
          res = await api.put(`/update/school_infrastructure/${this.form._id}`, { items: this.form });
        }
        if (res.data.code === 1) {
          this.showResult('success', 'ສຳເລັດແລ້ວ', 'ບັນທຶກຂໍ້ມູນໂຄງລ່າງຮຽບຮ້ອຍແລ້ວ');
          await this.fetchInfrastructureData();
        }
      } catch (e) {
        this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', 'ບໍ່ສາມາດບັນທຶກຂໍ້ມູນໄດ້');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.infrastructure-container { animation: fadeIn 0.4s ease; max-width: 1100px; margin: 0 auto; }

/* Info card */
.info-card {
  background: white;
  border-radius: 16px;
  padding: 24px 28px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  border-left: 4px solid var(--lao);
}
.section-label { font-size: 13px; font-weight: 700; color: var(--lao); margin-bottom: 18px; display: flex; align-items: center; gap: 8px; }

/* Auto field */
.auto-field { background: #f1f5f9 !important; color: #64748b; }
.auto-badge {
  display: inline-block; font-size: 10px; font-weight: 700;
  background: #e0f2fe; color: #0284c7; border-radius: 4px;
  padding: 1px 6px; margin-top: 4px;
}

/* Tabs */
.tabs-container { background: white; border-radius: 16px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.07); }
.tabs-nav { display: flex; background: #f1f5f9; padding: 10px 15px 0; gap: 5px; overflow-x: auto; }
.tab-btn {
  padding: 11px 20px; border: none; background: none; cursor: pointer;
  font-weight: 600; font-size: 13px; color: #64748b; border-radius: 10px 10px 0 0;
  transition: 0.2s; display: flex; align-items: center; gap: 7px; white-space: nowrap;
}
.tab-btn.active { background: white; color: var(--lao); }
.badge-count {
  background: var(--lao); color: white; border-radius: 12px;
  padding: 1px 7px; font-size: 11px; min-width: 20px; text-align: center;
}
.tab-content { padding: 28px; }

/* Fields */
.field-row   { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 16px; }
.field-row-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin-bottom: 16px; }
.field-row-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 16px; }

.form-group { position: relative; }
.form-group label { display: block; font-size: 13px; color: #475569; margin-bottom: 6px; font-weight: 600; }
.form-group input, .form-group select {
  width: 100%; padding: 9px 11px; border: 1px solid #e2e8f0;
  border-radius: 8px; font-size: 14px; box-sizing: border-box;
  font-family: 'Phetsarath OT', inherit;
}
.form-group input:focus, .form-group select:focus { outline: none; border-color: var(--lao); box-shadow: 0 0 0 3px rgba(0,63,138,0.1); }

/* Section titles */
.section-title { font-weight: 700; color: var(--lao); font-size: 14px; margin-bottom: 14px; padding-bottom: 8px; border-bottom: 2px solid #e2e8f0; }
.mt-4 { margin-top: 28px; }
.mb-3 { margin-bottom: 12px; }
.mb-4 { margin-bottom: 20px; }

/* Conditional field highlight */
.conditional-field { background: #f0f9ff; border-left: 3px solid #38bdf8; padding: 14px 16px; border-radius: 0 8px 8px 0; margin-bottom: 16px; }
.cond-flag { font-size: 11px; color: #0284c7; font-weight: 700; margin-bottom: 8px; }

/* Checkbox grid for other schools */
.checkbox-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 10px; }
.check-item {
  display: flex; align-items: center; gap: 10px; padding: 10px 14px;
  background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px;
  cursor: pointer; transition: 0.15s; font-size: 14px;
}
.check-item:hover { background: #eff6ff; border-color: #93c5fd; }
.check-item input[type="checkbox"] { width: 16px; height: 16px; cursor: pointer; }
.check-item.disabled { opacity: 0.4; cursor: not-allowed; }

/* Alert info */
.alert-info { background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; padding: 10px 14px; font-size: 13px; color: #1d4ed8; display: flex; align-items: center; gap: 8px; }

/* Summary banner */
.summary-banner { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; background: #f0f9ff; padding: 18px; border-radius: 12px; border: 1px solid rgba(0,63,138,0.1); }
.summary-item { display: flex; align-items: center; gap: 12px; }
.summary-item i { font-size: 22px; color: var(--lao); }
.summary-item .details { display: flex; flex-direction: column; }
.summary-item .label { font-size: 11px; color: #64748b; font-weight: 700; text-transform: uppercase; }
.summary-item .value { font-size: 20px; color: var(--lao); font-weight: 700; }

/* Record cards */
.record-card { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 20px; }
.record-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 18px; padding-bottom: 10px; border-bottom: 1px dashed #cbd5e1; }
.record-header h4 { margin: 0; color: var(--lao); font-weight: 700; display: flex; align-items: center; gap: 8px; }

/* Condition grid */
.condition-section { background: white; border-radius: 8px; border: 1px solid #e2e8f0; padding: 16px; margin-top: 8px; }
.condition-title { font-size: 12px; font-weight: 700; color: #64748b; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px; }
.condition-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }

/* Villages */
.villages-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 12px; margin-bottom: 12px; }

/* Buttons */
.btn-add-record { width: 100%; padding: 13px; background: white; border: 2px dashed var(--lao); color: var(--lao); border-radius: 10px; cursor: pointer; font-weight: 700; margin-top: 8px; transition: 0.2s; display: flex; align-items: center; justify-content: center; gap: 8px; }
.btn-add-record:hover { background: #eff6ff; }
.btn-remove-text { background: none; border: none; color: #ef4444; cursor: pointer; font-size: 13px; font-weight: 600; display: flex; align-items: center; gap: 5px; }

.input-group { display: flex; gap: 8px; }
.btn-del-mini { background: #fee2e2; color: #ef4444; border: none; border-radius: 6px; width: 34px; cursor: pointer; font-weight: 700; font-size: 16px; flex-shrink: 0; }
.btn-add-mini { background: #eff6ff; color: var(--lao); border: 1px solid #bfdbfe; padding: 7px 16px; border-radius: 7px; cursor: pointer; font-size: 13px; font-weight: 700; display: inline-flex; align-items: center; gap: 6px; }

/* Status selector */
.status-selector { display: flex; background: #f1f5f9; padding: 4px; border-radius: 10px; gap: 4px; }
.status-btn { flex: 1; padding: 10px; border-radius: 8px; cursor: pointer; font-weight: 600; text-align: center; font-size: 13px; }
.status-btn input { display: none; }
.status-btn.p.active { background: #10b981; color: white; }
.status-btn.a.active { background: #64748b; color: white; }

/* Hint & validation */
.hint-text { font-size: 13px; color: #64748b; display: flex; align-items: center; gap: 6px; }
.validation-warning {
  margin-top: 8px; background: #fef3c7; border: 1px solid #fcd34d; color: #92400e;
  border-radius: 8px; padding: 10px 14px; font-size: 13px; font-weight: 600;
  display: flex; align-items: center; gap: 8px;
}

/* Save button */
.form-actions-wrapper { text-align: right; }
.btn-save { background: var(--lao); color: white; padding: 14px 50px; border-radius: 10px; font-weight: 700; border: none; cursor: pointer; transition: 0.3s; font-size: 15px; display: inline-flex; align-items: center; gap: 8px; }
.btn-save:hover { background: #002d62; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,63,138,0.3); }
.btn-save:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }

/* Modal */
.modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 9999; }
.custom-modal-card { background: white; width: 100%; max-width: 450px; border-radius: 16px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.15); overflow: hidden; animation: modalPop 0.3s ease; }
.result-modal { text-align: center; padding: 40px 30px; }
.modal-icon { font-size: 60px; margin-bottom: 20px; }
.modal-icon.success { color: #10b981; }
.modal-icon.error { color: #ef4444; }
.modal-content-area h2 { margin: 0 0 8px; color: #1e293b; }
.modal-content-area p { color: #64748b; margin: 0; }
.modal-footer-actions { margin-top: 28px; }
.btn-modal-primary { padding: 12px 40px; border: none; border-radius: 10px; font-weight: 700; cursor: pointer; font-size: 15px; }
.btn-modal-primary.success { background: #10b981; color: white; }
.btn-modal-primary.error { background: #ef4444; color: white; }

@keyframes modalPop { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

.loading-state-full { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 300px; color: var(--lao); gap: 16px; }

@media (max-width: 900px) {
  .field-row-4 { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
  .field-row, .field-row-3, .field-row-4, .condition-grid, .summary-banner { grid-template-columns: 1fr; }
  .tabs-nav { overflow-x: auto; white-space: nowrap; }
}
</style>
